module.exports = __webpack_public_path__ + "fonts/lato-v11-latin-regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/js/core/fonts/lato-v11-latin-regular.woff2
// module id = 17
// module chunks = 0